import { motion, AnimatePresence } from 'framer-motion';
import React, { useCallback } from 'react';
import styled from 'styled-components';

import Box from 'components/shared/Box';
import Icon from 'components/shared/Icon';

import close from 'images/close.svg';

interface BaseModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  header: string;
  onClose?: () => void;
  children?: React.ReactNode;
}

const BaseModalContainer = styled.div`
  width: 100vw;
  height: 100vh;

  position: fixed;
  top: 0;
  left: 0;

  z-index: 2;

  background: rgba(248, 250, 252, 0.95);

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 20px;
`;

const BaseModalInnerContainer = styled.div`
  @media only screen and (min-width: 768px) {
    width: 40%;
    margin: 0 auto;
  }
`;

const IconContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
`;

const MotionDiv = motion(styled.div`
  width: 100%;
`);

const BaseModal: React.FC<BaseModalProps> = ({
  isOpen,
  setIsOpen,
  header,
  onClose,
  children,
}) => {
  const closeModal = useCallback(() => {
    setIsOpen(false);
    onClose?.();
  }, [setIsOpen, onClose]);

  return (
    <AnimatePresence>
      {isOpen ? (
        <BaseModalContainer onClick={closeModal}>
          <MotionDiv
            key={`${header.toLowerCase().split(' ').join('-')}-modal`}
            initial={{ opacity: 0, y: '-100vh' }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: '-100vh' }}
            transition={{ duration: 0.5 }}
          >
            <BaseModalInnerContainer>
              <Box
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <IconContainer>
                  <Icon src={close} onClick={closeModal} />
                </IconContainer>
                {children}
              </Box>
            </BaseModalInnerContainer>
          </MotionDiv>
        </BaseModalContainer>
      ) : null}
    </AnimatePresence>
  );
};

export default BaseModal;
